import { useConfigurationMeta, useCsCfgObject, useRootCfgObject, } from "@plansoft-configuration-renderer/framework";
import { useLayoutData } from "./useLayoutData";
/**
 * Fetches the layout and returns the data
 * - can only be used inside `ConfigurationController`
 * @private
 * @param options
 * @returns
 */
export function useLayout(options) {
    const cfgObject = useCsCfgObject();
    const rootObject = useRootCfgObject();
    const { baseUrl: basePath } = useConfigurationMeta();
    const cfgObjectId = cfgObject.id;
    const rootCfgObjectId = rootObject === null || rootObject === void 0 ? void 0 : rootObject.id;
    return useLayoutData(Object.assign(Object.assign({}, options), { basePath, cfgObjectId, rootCfgObjectId }));
}
//# sourceMappingURL=useLayout.js.map